
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Subscriptions extends Vue {}
